import React from 'react';
import Basic from './Basic';
import MilestoneFields from './MilestoneFields';
import Boq from './Boq';

const CreateTicketForm = ({ projectMilestones, setProjectMilestones, showBoq, setShowBoq }) => {
    return (
        <div className='py-4 flex flex-col gap-8 overflow-y-auto relative'>
            <div>
                <Basic setProjectMilestones={setProjectMilestones} projectMilestones={projectMilestones} />
            </div>

            {projectMilestones.length > 0 && (
                <div className="space-y-6">
                    {projectMilestones.map((milestone, index) => (
                        <div key={milestone.id}>
                            <MilestoneFields
                                id={milestone.id}
                                setProjectMilestones={setProjectMilestones}
                                addNew={index === projectMilestones.length - 1}
                                type={milestone.type}
                                milestone={milestone}
                                title={milestone.title}
                                index={index}
                            />
                        </div>
                    ))}
                </div>
            )}

            {showBoq && <Boq setShowBoq={setShowBoq} />}
        </div>
    );
};

export default CreateTicketForm;
